import {inject, Injectable} from '@angular/core';
import {ProductCardApiService} from "../../../../services-api/product-card-api.service";
import {BaseModalApiService} from "../../../../../../../core/components/modals/services/base-modal-api.service";
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";
import {GetDataInModalParams} from "../../../../types/product-card-modals.types";
import {RecordUpdateRequestParams} from "../../../../../../../core/types/records-table.types";
import {BaseMarketingBlockPathStateService} from "./base-marketing-block-path-state.service";
import {CreateMarketingBlockData, MarketingBlockData} from "../types/base-marketing-block-types";
import {
  AttachProductCardFileParams,
  DeleteFileParams,
  GetFilesParams
} from "../../../../types/product-card-files.types";
import {ProductCardFilesApiService} from "../../../../services-api/product-card-files-api.service";

@Injectable({
  providedIn: 'root'
})
export class BaseMarketingBlockModalService {
  private productCardApiService: ProductCardApiService = inject(ProductCardApiService);
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);
  private baseMarketingBlockPathStateService: BaseMarketingBlockPathStateService = inject(BaseMarketingBlockPathStateService);
  private productCardFilesApiService: ProductCardFilesApiService = inject(ProductCardFilesApiService);

  public setDataInModalParams(parentId: number): GetDataInModalParams {
    return {
      path: this.baseMarketingBlockPathStateService.pathState(),
      queryParams: { marketingBlockId: parentId }
    };
  }

  public getDataInModal<T>(getDataInModalParams: GetDataInModalParams): Promise<Array<T>> {
    return new Promise((resolve, reject) => {
      this.productCardApiService.fetchDataInModal<T>(getDataInModalParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public createData(createMarketingBlockData: CreateMarketingBlockData): Promise<MarketingBlockData> {
    return new Promise((resolve, reject) => {
      this.baseModalApiService.createDataInModal<CreateMarketingBlockData, MarketingBlockData>(createMarketingBlockData, this.baseMarketingBlockPathStateService.pathState()).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public updatedRecordField<T>(recordUpdateRequestParams: RecordUpdateRequestParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.updateRecord<T>(recordUpdateRequestParams).subscribe({
        next: (recordData: T) => resolve(recordData),
        error: (error) => reject(error)
      });
    });
  }

  public deleteRecord(recordId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.deleteRecord(this.baseMarketingBlockPathStateService.pathState(), recordId).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public getFiles<T>(getFilesParams: GetFilesParams): Promise<Array<T>> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.fetchFiles<T>(getFilesParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public deleteFile(deleteFileParams: DeleteFileParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.deleteFile(deleteFileParams).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public attachFile<T>(attachProductCardFileParams: AttachProductCardFileParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.attachFile<T>(attachProductCardFileParams).subscribe({
        next: (data: T) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }
}
